import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { create } from 'zustand';

const KEY = 'vapsilver-cookies-consent';

/**
 * La visibilidad sale del componente porque el botón flotante de WhatsApp vive en
 * esta misma esquina y tiene que apartarse mientras el aviso esté en pantalla.
 */
export const useCookieBanner = create<{ visible: boolean; setVisible: (v: boolean) => void }>((set) => ({
  visible: false,
  setVisible: (visible) => set({ visible }),
}));

export default function CookieBanner() {
  const { visible, setVisible } = useCookieBanner();

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const setChoice = (choice: 'all' | 'essential') => {
    localStorage.setItem(KEY, JSON.stringify({ choice, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="region"
      aria-label="Aviso de cookies"
      className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 sm:max-w-sm z-50 card p-5 shadow-elev"
    >
      <p className="text-sm text-bone-100 mb-2 font-medium">Privacidad y cookies</p>
      <p className="text-xs text-bone-300 leading-relaxed mb-4">
        Usamos cookies estrictamente necesarias para el funcionamiento del carrito.
        Si activamos cookies analíticas, te pediremos consentimiento previo.
        Lee nuestra <Link to="/politica-cookies" className="text-vapor-400 underline">política de cookies</Link>.
      </p>
      <div className="flex gap-2">
        <button onClick={() => setChoice('essential')} className="btn-ghost flex-1 !py-2 !px-3 text-xs">
          Solo esenciales
        </button>
        <button onClick={() => setChoice('all')} className="btn-primary flex-1 !py-2 !px-3 text-xs">
          Aceptar todas
        </button>
      </div>
    </div>
  );
}

